import React from "react";

export type Dow = {
  docs_received?: string; docs_read?: boolean; code_ack?: string; disclosure_signature?: string; maiden_confirm?: string;
  suspended?: string; revoked?: string; driving_explanation?: string;
  location?: string; role?: string; position?: string; activities?: string[]; dismissal?: string; dismissal_explanation?: string;
  privacy_signature?: string;
};

export const DOW_LABELS = ["Getting started", "About you", "Where you've lived", "Court & ministry", "Authorization", "Review & submit"];

export type OrgWords = { TC: string; tc: string; T: string; t: string };
export const orgWords = (org?: string): OrgWords => org
  ? { TC: org, tc: org, T: org, t: org }
  : { TC: "The Catholic Diocese of Wilmington", tc: "the Catholic Diocese of Wilmington", T: "The Diocese of Wilmington", t: "the Diocese of Wilmington" };

export const signed = (v?: string) => (v || "").trim().length >= 3;

export const today = () => new Date().toLocaleDateString("en-US");

export function SignLine({ label, value, onChange, testId }: { label: string; value?: string; onChange: (v: string) => void; testId: string }) {
  return (
    <div className="grid gap-4 sm:grid-cols-[1fr_160px]">
      <label className="block">
        <span className="field-label">{label} (type your full name)</span>
        <input data-testid={testId} className="field-input font-heading text-lg italic" value={value || ""} onChange={(e) => onChange(e.target.value)} />
      </label>
      <label className="block">
        <span className="field-label">Date</span>
        <input disabled className="field-input bg-slate-50" value={today()} />
      </label>
    </div>
  );
}
